import Service from "../AuthService";

const statistics = {
  getStatistics(params) {
    return Service.get(`/api/statistic`, {
      params: params
    })
  },
  getStatisticById(id) {
    return Service.get(`/api/statistic/${id}`);
  },
  createStatistic(data) {
    return Service.post(`/api/statistic`, data);
  },
  updateStatistic(id, data) {
    return Service.put(`/api/statistic/${id}`, data);
  },
  deleteStatistic(id) {
    return Service.delete(`/api/statistic/${id}`);
  }
}

export default statistics
